import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.approval.list');
import { OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-approval-list',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.approval.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminApprovalListComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() listMode: string = 'pending';

    public draftTab: string = 'new';
    public items: any = [];
    public loaded: boolean = false;
    public search: any = { page: 1 };

    public pagination: any = {
        end: -1,
        start: -1,
    };

    // Search/filter/sort for completed mode
    public searchKeyword: string = '';
    public filterCategory: string = '';
    public sortField: string = 'created';
    public sortOrder: string = 'desc';

    public statusMap: any = {
        draft: '임시저장',
        pending: '승인대기',
        approved: '종결',
        rejected: '반려',
        withdrawn: '회수',
        revision_requested: '보완요청'
    };

    public statusColorMap: any = {
        draft: 'bg-zinc-100 text-zinc-600',
        pending: 'bg-yellow-100 text-yellow-700',
        approved: 'bg-green-100 text-green-700',
        rejected: 'bg-red-100 text-red-700',
        withdrawn: 'bg-zinc-100 text-zinc-500',
        revision_requested: 'bg-orange-100 text-orange-700'
    };

    public categoryMap: any = {
        internal: '내부',
        fund_invest: '조합/투자기업',
        finance: '자금',
        support: '지원사업',
        tips: 'TIPS'
    };

    public categories: any[] = [
        { key: '', label: '전체' },
        { key: 'internal', label: '내부' },
        { key: 'fund_invest', label: '조합/투자기업' },
        { key: 'finance', label: '자금' },
        { key: 'support', label: '지원사업' },
        { key: 'tips', label: 'TIPS' }
    ];

    public modeTitleMap: any = {
        pending: '결재대기 문서',
        draft: '기안 작성',
        inbox: '결재함',
        completed: '결재완료 및 공람 문서'
    };

    public modeDescMap: any = {
        pending: '내 결재 차례이거나 아직 결재 전 회수 가능한 문서',
        draft: '임시저장 및 반려/보완요청된 문서',
        inbox: '현재 진행중인 결재 문서',
        completed: '결재완료 및 공람 문서'
    };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['listMode'] && !changes['listMode'].firstChange) {
            this.resetSearch();
            await this.load();
        }
    }

    public resetSearch() {
        this.searchKeyword = '';
        this.filterCategory = '';
        this.sortField = 'created';
        this.sortOrder = 'desc';
    }

    public async load(page: number = 1) {
        this.search.page = page;
        this.loaded = false;
        this.items = [];
        await this.service.render();
        const params: any = { page, mode: this.listMode };
        if (this.listMode === 'completed') {
            params.keyword = this.searchKeyword;
            params.category = this.filterCategory;
            params.sortField = this.sortField;
            params.sortOrder = this.sortOrder;
        }
        const { code, data } = await wiz.call("search", params);
        if (code != 200) return;
        let { rows, lastpage } = data;
        const startpage = Math.floor((page - 1) / 10) * 10 + 1;
        this.items = rows;
        this.pagination.start = startpage;
        this.pagination.end = lastpage;
        this.loaded = true;
        await this.service.render();
    }

    public async searchCompleted() {
        await this.load(1);
    }

    public async onCategoryChange() {
        await this.load(1);
    }

    public async toggleSort(field: string) {
        if (this.sortField === field) {
            this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc';
        } else {
            this.sortField = field;
            this.sortOrder = field === 'requester_name' ? 'asc' : 'desc';
        }
        await this.load(1);
    }

    public async move(item: any) {
        await this.service.href(`/admin/system/approval/${this.listMode}/${item.id}`);
    }

    public async switchDraftTab(tab: string) {
        this.draftTab = tab;
        if (tab === 'list') {
            await this.load();
        }
        await this.service.render();
    }

    public async createNew() {
        await this.service.href('/admin/system/approval/draft/new');
    }
}

export default PortalLpsysadminApprovalListComponent;